import { __decorate } from "tslib";
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { queryDeviceRtspPreviewAddress } from '@blade-sxp/task-management/api/creat-task/index';
import { HandleDeviceIdTree } from '@blade/common/store/deviceTree';
import { isEmpty, chunk, cloneDeep } from 'lodash';
import { setCustomOptions } from '@blade-sxp/task-management/constant/drawer-options';
import { TrafficTypeModule } from '@blade-sxp/task-management/store/traffic-type';
import VideoDrawer from '@blade/common/components/task-management/simple-drawer.vue';
import { MapPolygonsModule } from '@blade-sxp/task-management/store/mapPolygons';
import colors from '@/styles/color.scss';
const Service = { queryDeviceRtspPreviewAddress };
let TrafficPoint = class TrafficPoint extends Vue {
    selsectDeviceIdList;
    disabled;
    roi = require('@blade-sxp/task-management/assets/roi-and-direction.png');
    uncheckedImg = require('@blade-sxp/task-management/assets/subtract.png');
    multiple = true;
    selectDeviceIndex = 0;
    rtspAddress = '';
    selectedDeviceIdList = [];
    drawButtons = ['polygon'];
    limits = {};
    isPlay = true;
    paintState = false;
    rtspUrl = '';
    showSelect = false;
    dataSource = [];
    options = setCustomOptions('polygon');
    styleProp = {
        width: 644,
        height: 378,
    };
    deviceIdList = [];
    mostDarwerNumber = false;
    videoPlayStatus = false;
    selectDeviceId = 0;
    ponitDataList = [];
    mouseTip = 'roiTip';
    completedNumber = 0;
    activeBackgroundId = '';
    get selsectLen() {
        return this.selectedDeviceIdList?.length;
    }
    get ponitData() {
        return this.ponitDataList?.length > 0;
    }
    get graphHoverId() {
        return MapPolygonsModule.graphHoverId;
    }
    getGraphHover(id) {
        this.activeBackgroundId = id;
    }
    selectTreeData(val) {
        this.deviceIdList = val;
    }
    onChangeSelectedDeviceIdList() {
        if (!isEmpty(this.selectedDeviceIdList)) {
            const status = this.selectedDeviceIdList?.every((item) => item.isComplete === false);
            const isData = this.selectedDeviceIdList?.filter((item) => item.isComplete === false);
            this.completedNumber = isData?.length;
            TrafficTypeModule.updataAllCompleted(status);
        }
        else {
            TrafficTypeModule.updataAllCompleted(false);
        }
    }
    onchnageDeviceList(val) {
        if (!isEmpty(val)) {
            this.setRetrogradeData(val);
            this.selectedDeviceIdList = this.getSelectDeviceIdList(val);
            const id = Number(val[0]);
            this.selectDeviceId = id;
            this.getRtsp(id, 0);
        }
        else {
            this.selectedDeviceIdList = [];
            this.selectDeviceIndex = 0;
            this.selectDeviceId = 0;
            TrafficTypeModule.retrogradeMapData.clear();
        }
    }
    beforeDestroy() {
        TrafficTypeModule.retrogradeMapData.clear();
        TrafficTypeModule.updataAllCompleted(false);
    }
    setRetrogradeData(val) {
        let temporaryMap = new Map();
        const pointMap = cloneDeep(TrafficTypeModule.retrogradeMapData);
        val?.forEach((item) => {
            const isExistence = pointMap.has(item);
            if (isExistence) {
                const getMapData = pointMap?.get(item);
                if (getMapData) {
                    temporaryMap.set(item, getMapData);
                }
            }
            else {
                temporaryMap.set(item, []);
            }
        });
        TrafficTypeModule.retrogradeMapData.clear();
        if (!isEmpty(temporaryMap)) {
            temporaryMap.forEach((value, key) => {
                TrafficTypeModule.retrogradeMapData.set(key, value);
            });
        }
    }
    removeValue(val) {
        const isKey = TrafficTypeModule.retrogradeMapData.has(val);
        if (isKey) {
            TrafficTypeModule.retrogradeMapData.delete(val);
        }
    }
    getPlaybackStatus() {
        this.videoPlayStatus = true;
    }
    deleteRoi(item) {
        let dom = this.$refs.drawerPlot.$refs.simpleDrawer;
        if (!isEmpty(item)) {
            item?.forEach((item) => {
                if (!isEmpty(dom)) {
                    dom.deleteGraph(item.id);
                }
            });
        }
        dom = null;
        this.$nextTick(() => {
            this.paintState = false;
            this.mouseTip = 'roiTip';
            this.drawButtons = ['polygon'];
            this.options = setCustomOptions('polygon');
        });
    }
    deleteDeviceId(id) {
        const index = this.deviceIdList.indexOf(id);
        if (index > -1) {
            const data = [...this.deviceIdList];
            data.splice(index, 1);
            this.deviceIdList = data;
        }
        this.$emit('deleteDeviceId', id);
    }
    startDraw() {
        if (this.paintState) {
            this.paintState = false;
        }
        else {
            const data = TrafficTypeModule.retrogradeMapData.get(String(this.selectDeviceId));
            if (data) {
                const len = data?.length % 2;
                if (len === 0) {
                    this.mouseTip = 'roiTip';
                }
                else {
                    this.mouseTip = 'dirTip';
                }
            }
            this.paintState = true;
        }
    }
    getDrawend(data) {
        TrafficTypeModule.retrogradeMapData.set(String(this.selectDeviceId), data);
        let twoDimensional = [];
        twoDimensional = chunk(data, 2);
        this.ponitDataList = twoDimensional;
        const len = data.length;
        const pointType = len % 2;
        if (!isEmpty(data) && pointType === 1) {
            const type = data[0].type;
            if (type === 'polygon') {
                this.$nextTick(() => {
                    this.drawButtons = ['arrow'];
                    this.options = setCustomOptions('arrow');
                    this.mouseTip = 'dirTip';
                    this.paintState = true;
                });
            }
        }
        if (pointType === 0) {
            this.$nextTick(() => {
                this.paintState = false;
                this.mouseTip = 'roiTip';
                this.drawButtons = ['polygon'];
                this.options = setCustomOptions('polygon');
            });
        }
        this.isDeleteTip();
        this.isComplete();
    }
    isComplete() {
        const currentDeviceData = TrafficTypeModule.retrogradeMapData.get(String(this.selectDeviceId));
        const currentLen = currentDeviceData?.length;
        const baseCouple = currentLen % 2;
        this.selectedDeviceIdList?.forEach((item) => {
            if (String(item.id) === String(this.selectDeviceId)) {
                if (currentLen >= 2 && baseCouple === 0) {
                    item.isComplete = false;
                }
                else {
                    item.isComplete = true;
                }
            }
        });
    }
    isDeleteTip() {
        if (this.selectDeviceId) {
            const dataSelect = TrafficTypeModule.retrogradeMapData.get(String(this.selectDeviceId));
            if (!isEmpty(dataSelect)) {
                const len = dataSelect?.length;
                if (len < 10) {
                    this.mostDarwerNumber = false;
                }
                else {
                    this.mostDarwerNumber = true;
                }
            }
        }
    }
    getCurrentDataSoure(id) {
        this.dataSource = [];
        this.ponitDataList = [];
        const isKey = TrafficTypeModule.retrogradeMapData.has(id);
        if (isKey) {
            const currentData = TrafficTypeModule.retrogradeMapData.get(id);
            this.dataSource = currentData || [];
            this.$nextTick(() => {
                if (!isEmpty(this.dataSource)) {
                    this.ponitDataList = chunk(this.dataSource, 2);
                }
                else {
                    this.ponitDataList = [];
                }
            });
        }
    }
    getRtsp(id, index) {
        this.selectDeviceIndex = index;
        this.selectDeviceId = id;
        this.getCurrentDataSoure(String(id));
        this.videoPlayStatus = false;
        this.isDeleteTip();
        this.mouseTip = 'roiTip';
        this.drawButtons = ['polygon'];
        this.options = setCustomOptions('polygon');
        this.paintState = false;
        Service.queryDeviceRtspPreviewAddress(String(id)).then((res) => {
            this.rtspUrl = res?.rtspPreviewAddress;
        });
    }
    getSelectDeviceIdList(val) {
        let data = [];
        const deviceList = HandleDeviceIdTree.treeToDeviceIdList;
        if (val && deviceList) {
            deviceList.forEach((item) => {
                val.forEach((el) => {
                    const isData = TrafficTypeModule.retrogradeMapData.get(String(el));
                    const isStatus = isEmpty(isData);
                    if (item.id === el && item.nodeType === 'DEVICE') {
                        data.push({ ...item, isComplete: isStatus });
                    }
                });
            });
        }
        return data;
    }
    roiAreaHover(atlas) {
        const graph = atlas.find((d) => d.type === 'polygon');
        if (graph?.id === this.activeBackgroundId) {
            return colors.deviceCascaderBg;
        }
        else {
            return colors.white;
        }
    }
    mouseenterGetId(atlas) {
        if (this.ponitDataList.length === 1)
            return;
        const graph = atlas.find((d) => d.type === 'polygon');
        if (graph?.type === 'rect' || graph?.type === 'polygon') {
            MapPolygonsModule.updataGraphHover(graph.id);
        }
    }
};
__decorate([
    Prop()
], TrafficPoint.prototype, "selsectDeviceIdList", void 0);
__decorate([
    Prop({ default: false, type: Boolean })
], TrafficPoint.prototype, "disabled", void 0);
__decorate([
    Watch('graphHoverId', { deep: true })
], TrafficPoint.prototype, "getGraphHover", null);
__decorate([
    Watch('selsectDeviceIdList', { immediate: true, deep: true })
], TrafficPoint.prototype, "selectTreeData", null);
__decorate([
    Watch('selectedDeviceIdList', { deep: true, immediate: true })
], TrafficPoint.prototype, "onChangeSelectedDeviceIdList", null);
__decorate([
    Watch('deviceIdList', { immediate: true })
], TrafficPoint.prototype, "onchnageDeviceList", null);
TrafficPoint = __decorate([
    Component({
        name: 'TrafficPoint',
        components: {
            'st-video-drawer': VideoDrawer,
        },
        i18n: {
            messages: {
                en: {
                    device: 'Device',
                    roiTip: 'click left button to set points and link them to draw ROI area, click right button or press Esc to cancel',
                    dirTip: 'ROI is finished, please draw the direction. click and pull left button to draw a line with arrow to define detection, click right or press Esc to cancel',
                    roiDetailTip: 'Please delete the existing ROI area before add a new one',
                    examples: 'Example',
                    arrowTip: 'Please continue drawing direction',
                    examplesText: 'ROI and Direction',
                    noData: 'please add ROI area and direction',
                    addDevice: 'Added Device',
                    total: 'Total',
                    completed: 'Completed',
                    notCompleted: 'the device was not completed',
                },
                zh: {
                    device: '设备',
                    roiTip: '单击左键设置点并将其链接到绘制ROI区域，单击右键或按Esc取消',
                    dirTip: 'ROI已完成，请绘制方向。单击并向左拉按钮以绘制一条带箭头的线来定义检测，单击右键或按Esc键取消',
                    roiDetailTip: '请先删除现有的ROI区域，再添加新的ROI区域',
                    examples: '示例',
                    arrowTip: '请继续绘制方向',
                    examplesText: '区域和方向',
                    noData: '请添加区域和方向',
                    addDevice: '添加设备',
                    total: '总数',
                    completed: '已完成',
                    notCompleted: '设备未完成',
                },
            },
        },
    })
], TrafficPoint);
export default TrafficPoint;
